import React, {Component} from 'react';
import {observer} from 'mobx-react';
import {Link} from 'react-router-dom';
import {AppStore} from 'js/stores'; // singleton stores
import {BASE_URL, LABEL} from 'js/constants';
import styles from 'css/components/breadcrumbs.css';

@observer
/**
 * bread crumbs
 */
export default class BreadCrumbs extends Component {
  /**
   * render jsx
   * @return {jsx}
   */
  render() {
    return (
      <div className={styles.breadcrumbs}>
        <div className={styles.frame}>
          <a onClick={() => {
            location.href = 'https://www.bil.jp/';
          }}>
            ホーム
          </a>
          <Link to={BASE_URL}>
            市場創造PR力診断{LABEL.appType}
          </Link>
          {1 <= AppStore.breadcrumbsLevel && (
            <Link to={`${BASE_URL}/result`}>診断結果</Link>
          )}
          {
            2 <= AppStore.breadcrumbsLevel &&
            'web' == AppStore.selectAppType &&
          (
            <Link to={`${BASE_URL}/registration`}>市場創造フェーズ</Link>
          )}
          {3 <= AppStore.breadcrumbsLevel && (
            <a>市場創造PR</a>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/breadcrumbs/index.js